import { useTheme } from "@emotion/react";
import { useCallback, useContext, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { IconButton } from "@material-ui/core";
import {
  Delete as DeleteIcon, Search as PageviewIcon,
} from '@material-ui/icons';

import TarifaContext from "../../../../contexts/registrations/tarifa/TarifaContext";
import SimpleConsultPageTemplate from "../../../../templates/simple-consult-page/SimpleConsultPageTemplate/SimpleConsultPageTemplate";
import { isAlternativeLoadingStatus } from "../../../../utils/store/store-utils";
import { changeToCreateMode,resetMode,resetModel, selectTarifa } from '../../../../features/tarifa/tarifaSlice'
import { userHasDeleteRole } from "../../../../components/perfil/perfil-utils";

export default function TarifaConsultPage({ authInfo = {} }) {

    const { t } = useTranslation();
    const theme = useTheme();
    const history = useHistory();

    const { status } = useContext(TarifaContext);

    const dispatch = useDispatch();

    const tarifas = useSelector(selectTarifa)

    const [pageConfig, setPageConfig] = useState({
        currentPage: 0,
        pageSize: 10,
        filterInputValue: '',
    }); 

    const handleClickOnButtonNew = useCallback( (event) => {
      event.stopPropagation();
      dispatch(changeToCreateMode());
    });

    const handleConfigChange = useCallback( () => {

    });

    const handleActivateInactivate = useCallback( () => {

    });

    const handleClickOnEditButton = useCallback( () => {

    })

    const breadcrumbs = useMemo(
    () => [
        {
        link: {
            to: '/',
            name: t('com.muralis.qcx.inicio'),
        },
        },
        {
        link: {
            to: t('com.muralis.qcx.url.moduloAgenciamento'),
            name: t('com.muralis.qcx.agenciamento.breadcrumbs.importacao'),
        },
        },
        {
        text: {
            name: t('com.muralis.qcx.agenciamento.tarifa'),
        },
        default: true,
        },
    ],
    []
    );

    const isAlternativeLoading = useMemo(() => (
      isAlternativeLoadingStatus(status)
    ), [status]);

    const columns = [
      {
        field: 'id',
        align: 'center',
        headerName: 'Código',
        headerAlign: 'center',
        type: 'string',
        flex: 60,
        valueGetter: ({ row }) => (
          row?.id
        ),
      },
      {
        field: 'descricao',
        headerName: 'Descrição',
        headerAlign: 'center',
        align: 'center',
        type: 'string',
        flex: 225,
        valueGetter: ({ row }) => (
          row?.description
        ),
      },
      {
        field: 'ativo',
        headerName: 'Ativo',
        headerAlign: 'center',
        align: 'center',
        type: 'boolean',
        flex: 80,
        valueGetter: ({ row }) => (
          row?.active
        ),
      },
      {
        field: 'actions',
        headerName: t('com.muralis.qcx.acoes.label'),
        headerAlign: 'center',
        align: 'center',
        flex: 80,
        renderCell: ({ row: { id, active } }) => (
          <>
            {userHasDeleteRole(authInfo, 'grupo-despesa-receita') && (
            <IconButton
              key={`stw-active${id}`}
              value={active}
              name={`stw-active-${id}`}
              onClick={(event) => handleActivateInactivate(event, id)}
            >
              <DeleteIcon color="error" />
            </IconButton>
            )}
            <IconButton
              key={`btn-view-${id}`}
              name={`btn-view-${id}`}
              onClick={(event) => handleClickOnEditButton(event, id)}
            >
              <PageviewIcon color="primary" />
            </IconButton>
          </>
        ),
      },
    ];

    const templateProps = {
      page: {
        title: t('com.muralis.qcx.tarifa_page.lista_tarifa'),
        breadcrumbs,
      },
      control: {
        buttonNew: {
          description: t('com.muralis.qcx.aereo.novoCadastro'),
          path: t('com.muralis.qcx.url.importacaoTarifaNovo'),
          onClick: handleClickOnButtonNew,
        },
      },
      table: {
        columns,
      },
    };
  
    return (
        <SimpleConsultPageTemplate
          pageProps={templateProps.page}
          controlProps={templateProps.control}
          tableProps={templateProps.table}
          tableData={[]}
          isLoading={isAlternativeLoading}
          buttonNewText={t('com.muralis.qcx.acoes.nova').toUpperCase()}
          multipleFilter
          authInfo={authInfo}
        />
    );

}